/** @prettier */

import React from 'react';
import { Route, Switch } from 'react-router';
import Loadable from 'react-loadable';
import ErrorBoundary from '@surfline/quiver-react/dist/ErrorBoundary';
import { withDevice } from '@surfline/quiver-react';
import KBYGPageContainer from '../../containers/routes/KBYGPageContainer';
import routesConfig from '../../routesConfig';
import RouteWithChildren from './RouteWithChildren';
import devicePropTypes from '../../propTypes/device';

/**
 * NOTE: For server side rendering to work properly, we have to instantiate the Loadable components
 * outside of the JSX so that they are preloaded when we call `Loadable.preloadAll()` on the server
 * side.
 */
const routes = routesConfig.map(
  ({ routeProps, loader, loading, modules, webpack, childRoutes }) => {
    const route = {
      routeProps,
      component: Loadable({ loader, loading, modules, webpack }),
    };
    if (childRoutes) {
      route.childRoutes = childRoutes.map(childRoute => ({
        routeProps: childRoute.routeProps,
        component: Loadable({
          loader: childRoute.loader,
          loading: childRoute.loading,
          modules: childRoute.modules,
          webpack: childRoute.webpack,
        }),
      }));
    }
    return route;
  }
);

const Routes = ({ device }) => (
  <React.StrictMode>
    <ErrorBoundary>
      <Route
        path="/"
        render={pageContainerProps => (
          <KBYGPageContainer {...pageContainerProps} device={device}>
            <Switch>
              {routes.map(({ routeProps, component: RouteComponent, childRoutes }) => (
                <Route
                  key={routeProps.path}
                  {...routeProps}
                  device={device}
                  render={props => {
                    if (childRoutes) {
                      return (
                        <RouteWithChildren
                          routeProps={props}
                          RouteComponent={RouteComponent}
                          childRoutes={childRoutes}
                          device={device}
                        />
                      );
                    }
                    return <RouteComponent {...props} device={device} />;
                  }}
                />
              ))}
            </Switch>
          </KBYGPageContainer>
        )}
      />
    </ErrorBoundary>
  </React.StrictMode>
);

Routes.propTypes = {
  device: devicePropTypes.isRequired,
};

export default withDevice(Routes);
